import { METRICS_GRADE_THRESHOLDS } from "@/constants";

export function getScoreTier(score) {
  if (score >= METRICS_GRADE_THRESHOLDS.HIGH) return "high";
  if (score >= METRICS_GRADE_THRESHOLDS.MEDIUM) return "medium";
  return "low";
}

export function studentInitials(student) {
  if (!student) return "";
  const firstInitial = (student.firstName || "").charAt(0).toUpperCase();
  const lastInitial = (student.lastName || "").charAt(0).toUpperCase();
  return `${firstInitial}${lastInitial}`;
}
